import React from 'react';
import { ArrowOutlined, OrderOutlined, TriangleDownOutlined } from '@kufox/icons';
import { ClassNames } from '@kufox/mui/emotion';
import Accordion from '@kufox/mui/Accordion';
import Dropdown from '@kufox/mui/Dropdown';
import useTheme from '@kufox/mui/hooks/useTheme';
import clsx from 'clsx';
import Link from '../../components/Link';
import { useLang } from '../../hookTool';
import { addSpmIntoQuery } from '../../common/tools';
import book from '../../../static/newHeader/book.svg';
import clockpurple from '../../../static/newHeader/clockpurple.svg';
import clockBlue from '../../../static/newHeader/clockBlue.svg';
import clockGreen from '../../../static/newHeader/clockGreen.svg';
import { long_language } from '../config';

const { AccordionPanel: Panel } = Accordion;

const useStyles = ({ color, inDrawer, isLong_language, isActive }) => {
  return {
    overlayWrapper: `
      width: ${inDrawer ? 'auto' : isLong_language ? '400px' : '300px'};
      margin-top: 22px;
      margin-bottom: ${inDrawer ? '16px' : '0'};
      border-radius: 4px;
      padding: ${inDrawer ? '0' : '16px 0'};
      background: ${inDrawer ? 'transparent' : color.base};
      box-shadow: ${inDrawer ? 'unset' : '0px 10px 60px rgba(0, 0, 0, 0.1)'};
      border-radius: 4px;
      & hr {
        margin: 16px 28px;
      }
    `,
    menuItem: `
      display: flex;
      width: 100%;
      height: ${inDrawer ? '48px' : '48px'};
      align-items: center;
      cursor: pointer;
      color: ${color.text};
      text-decoration: none !important;
      font-size: ${inDrawer ? '14px' : '16px'};
      position: relative;
      word-break: break-all;
      &:hover {
        background: ${color.cover4};
        color: ${color.text};
      }
      @keyframes move {
        0% {
          right: 20px;
        }
        100% {
          right: 18px;
        }
      }
      @keyframes changeColor {
        0% {
          fill: #737e8d;
        }
        100% {
          fill: #18bb97;
        }
      }
      & .arrow {
        display: none;
      }
      &:hover .arrow {
        display: block;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 20px;
        animation: move 0.3s linear forwards;
        -webkit-animation: move 0.3s linear forwards;
        & path {
          animation: changeColor 0.3s linear forwards;
          -webkit-animation: changeColor 0.3s linear forwards;
        }
      }
    `,
    menuItemText: `
      box-sizing: border-box;
      flex: 1;
      word-break: break-all;
      white-space: break-spaces;
      line-height: 20px;
      padding-right: 24px;
    `,
    hr: `
      background: ${color.divider};
      border: none;
      height: 1px;
    `,
    iconWrapper: `
      width: 24px;
      height: 24px;
      border-radius: 6px;
      margin: 0 16px 0 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      & img {
        width: 12px;
        height: 14px;
      }
      & .icon {
        width: 20px;
        height: 20px;
      }
    `,
    blue: `
      background: #5c95e8;
    `,
    purper: `
      background: #7a78e4;
    `,
    green: `
      background: #72948a;
    `,
    lightBlue: `
      background: #8cb2c1;
    `,
    gray: `
      background: #737e8d;
    `,
    accordion: `
      .KuxAccordion-head {
        padding: 8px 24px;
        font-size: 14px;
      }
    `,
  };
};

export default (props) => {
  const {
    currentLang,
    currency,
    hostConfig,
    isSub = false,
    className = '',
    themeColors,
    inDrawer,
    title,
  } = props;
  const theme = useTheme();
  const color = themeColors || theme.colors;
  const isLong_language = long_language.indexOf(currentLang) > -1;
  const classes = useStyles({ color, inDrawer, isLong_language });

  const { t } = useLang();

  const Overlay = () => {
    const { KUCOIN_HOST, KUMEX_HOST, FASTCOIN_HOST } = hostConfig;
    return (
      <ClassNames>
        {({ css }) => (
          <div className={css(classes.overlayWrapper)}>
            <Link
              href={addSpmIntoQuery(`${KUCOIN_HOST}/order/trade`, ['orders', '1'], currentLang)}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={1}
              lang={currentLang}
            >
              <div className={clsx(css(classes.iconWrapper), css(classes.blue))}>
                <img src={book} alt="order" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.coin.order')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
            <Link
              href={addSpmIntoQuery(`${KUCOIN_HOST}/order/margin`, ['orders', '2'], currentLang)}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={2}
              lang={currentLang}
            >
              <div className={clsx(css(classes.iconWrapper), css(classes.purper))}>
                <img src={book} alt="order" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.lever.order')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
            <Link
              href={addSpmIntoQuery(
                `${KUMEX_HOST}/assets/order-history`,
                ['orders', '3'],
                currentLang,
              )}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={3}
              lang={currentLang}
            >
              <div className={clsx(css(classes.iconWrapper), css(classes.green))}>
                <img src={book} alt="order" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.aggrement')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
            <Link
              // href={`${KUCOIN_HOST}/earn-account/order`}
              href={addSpmIntoQuery(
                `${KUCOIN_HOST}/earn-account/order`,
                ['orders', '4'],
                currentLang,
              )}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={3}
            >
              <div className={clsx(css(classes.iconWrapper), css(classes.lightBlue))}>
                <img src={book} alt="order" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.earnAccount.order')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
            <hr className={css(classes.hr)} />
            {!isSub && (
              <>
                <Link
                  href={addSpmIntoQuery(
                    `${FASTCOIN_HOST}/order_list?currency=${currency}`,
                    ['orders', '5'],
                    currentLang,
                  )}
                  className={css(classes.menuItem)}
                  data-modid="orders"
                  data-idx={4}
                  lang={currentLang}
                >
                  <div className={clsx(css(classes.iconWrapper), css(classes.gray))}>
                    <img src={book} alt="order" />
                  </div>
                  <div className={css(classes.menuItemText)}>{t('fiatCurreny.trade.order')}</div>
                  {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
                </Link>
                <hr className={css(classes.hr)} />
              </>
            )}

            <Link
              href={addSpmIntoQuery(
                `${KUCOIN_HOST}/order/trade/history`,
                ['orders', !isSub ? '6' : '5'],
                currentLang,
              )}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={!isSub ? '6' : '5'}
              lang={currentLang}
            >
              <div className={css(classes.iconWrapper)}>
                <img src={clockBlue} alt="order" className="icon" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.coin.history')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
            <Link
              href={addSpmIntoQuery(
                `${KUCOIN_HOST}/order/margin/history`,
                ['orders', !isSub ? '7' : '6'],
                currentLang,
              )}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={!isSub ? '7' : '6'}
              lang={currentLang}
            >
              <div className={css(classes.iconWrapper)}>
                <img src={clockpurple} alt="order" className="icon" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.lever.history')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
            <Link
              href={addSpmIntoQuery(
                `${KUMEX_HOST}/assets/trade-history`,
                ['orders', !isSub ? '8' : '7'],
                currentLang,
              )}
              className={css(classes.menuItem)}
              data-modid="orders"
              data-idx={!isSub ? '8' : '7'}
              lang={currentLang}
            >
              <div className={css(classes.iconWrapper)}>
                <img src={clockGreen} alt="order" className="icon" />
              </div>
              <div className={css(classes.menuItemText)}>{t('drop.aggrement.history')}</div>
              {!inDrawer && <ArrowOutlined width="13px" height="13px" className="arrow" />}
            </Link>
          </div>
        )}
      </ClassNames>
    );
  };

  if (inDrawer) {
    return (
      <ClassNames>
        {({ css }) => (
          <Accordion className={css(classes.accordion)}>
            <Panel header={title} key={0}>
              <Overlay />
            </Panel>
          </Accordion>
        )}
      </ClassNames>
    );
  }
  return (
    <Dropdown
      trigger="hover"
      overlay={<Overlay />}
      anchorProps={{ style: { 'display': 'block' } }}
      placement="bottom"
    >
      <div className={className || ''}>
        <OrderOutlined size="35" className="navIcon" />
      </div>
    </Dropdown>
  );
};
